import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'comunicacionPipe',
})
export class ComunicacionPipe implements PipeTransform {

  transform(items: any[], filter: any) {

    if (filter && items) {

      let now0 = new Date();
      let now01 = new Date();
      let now1 = new Date();

      now0.setHours(0);
      now0.setMinutes(0);
      now0.setSeconds(0);

      now1.setDate(now1.getDate() + 1);
      now1.setHours(0);
      now1.setMinutes(0);
      now1.setSeconds(0);


      if (filter['id_tipo'] && filter['id_tipo'] > 0) {

        items = items.filter(function (item) {
          return item.id_subtipo == filter['id_tipo'];
        });
      }

      if (filter['menu'] == 0) {
        items = items.filter(function (item) {
          return item.fecha <= now1.getTime();
        });
      }

      if (filter['menu'] == 2) {
        items = items.filter(function (item) {
          return item.fecha > now1.getTime();
        });
      }

    }

    return items;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/comunicacion/comunicacion.ts